import React from "react";
import { Link } from "react-router-dom";
import { LogIn, UserPlus } from "lucide-react";
import { useAuth } from "@/context/AuthContext";
import { loginHref, registerHref } from "@/lib/authReturn";

/** Renders children for members; guests see an account prompt and children never mount (no owner-only fetches). */
export function GuestGate({ children, area = "This area", testId = "guest-gate" }) {
  const { isGuest } = useAuth();
  if (!isGuest) return children;
  return (
    <div data-testid={testId} className="max-w-2xl border border-gold/30 bg-matte-card p-8">
      <div className="text-[10px] uppercase tracking-[0.4em] text-gold font-display">Guest Tour</div>
      <div className="mt-3 font-display uppercase text-white text-xl tracking-wider">{area} needs an account.</div>
      <p className="mt-3 text-sm text-white/60 leading-relaxed">
        You're touring Songwriter Square as a Guest. Sign in or create a free account to unlock {area.toLowerCase()} and everything tied to your own catalog.
      </p>
      <div className="mt-6 flex flex-col sm:flex-row gap-3">
        <Link to={registerHref()} data-testid={`${testId}-register`}
          className="h-10 px-5 flex items-center justify-center bg-goldSheen text-black border border-gold/60 font-display uppercase tracking-widest text-[11px] hover:brightness-110">
          <UserPlus className="h-3.5 w-3.5 mr-2" /> Create Free Account
        </Link>
        <Link to={loginHref()} data-testid={`${testId}-signin`}
          className="h-10 px-5 flex items-center justify-center border border-gold/40 text-gold font-display uppercase tracking-widest text-[11px] hover:bg-gold/10 hover:border-gold">
          <LogIn className="h-3.5 w-3.5 mr-2" /> Sign In
        </Link>
      </div>
    </div>
  );
}

export default GuestGate;
